import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { AnalyzeEffectsModule } from '@appStore/analyze/effects';
import { reducers } from '@appStore/analyze/reducers';
import * as fromServices from '@appStore/analyze/services';

export * from '@appStore/analyze/reducers';
export * from '@appStore/analyze/effects';
export * from '@appStore/analyze/actions';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('analyze', reducers), AnalyzeEffectsModule],
  providers: [...fromServices.services]
})
export class AnalyzeStoreModule {}
